import { useState } from 'react';
import GlossaryTermPopup from 'components/glossary-term-popup';

interface IProps {
    topicId: number;
    topicIds: number[];
    showViewRelatedButton?: boolean;
    viewRelatedButtonLabel?: string;
    customEvents?: {
        viewRelatedClick?: boolean;
    };
}

export default function GlossaryTermPopupWrapper({ props }: { props: IProps }) {
    const [showPopup, setShowPopup] = useState(true);

    return (
        showPopup && (
            <GlossaryTermPopup
                setShowPopup={setShowPopup}
                showPopup={showPopup}
                topicIds={props.topicIds}
                topicId={props.topicId}
                showViewRelatedButton={props.showViewRelatedButton}
                viewRelatedButtonLabel={props.viewRelatedButtonLabel}
                enableViewRelatedEvent={props.customEvents?.viewRelatedClick}
            />
        )
    );
}
